import FlexItem from './flex-item.vue'
export default FlexItem



// WEBPACK FOOTER //
// ./src/components/flex-item/index.js